"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "fromResize", {
  enumerable: true,
  get: function get() {
    return _resize.fromResize;
  }
});
exports.UI = void 0;

var _react = _interopRequireWildcard(require("react"));

var _operators = require("rxjs/operators");

require("./index.css");

var _resize = require("./resize");

var _Renderer = require("../Renderer");

var _Ticker = require("../Ticker");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var styleOf = function styleOf(renderer) {
  var scaleMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var _renderer$view = renderer.view,
      clientWidth = _renderer$view.clientWidth,
      clientHeight = _renderer$view.clientHeight,
      offsetLeft = _renderer$view.offsetLeft,
      offsetTop = _renderer$view.offsetTop;
  if (!scaleMode) return {
    width: clientWidth,
    height: clientHeight,
    left: offsetLeft,
    top: offsetTop
  };
  var width = renderer.width,
      height = renderer.height;
  return {
    width: width,
    height: height,
    transform: "scale(".concat(clientWidth / width, ", ").concat(clientHeight / height, ")"),
    left: (clientWidth - width) / 2 + offsetLeft,
    top: (clientHeight - height) / 2 + offsetTop
  };
};

var UI = function UI(_ref) {
  var id = _ref.id,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      outerStyle = _ref.style,
      children = _ref.children,
      scaleMode = _ref.scaleMode;
  var renderer = (0, _Renderer.useRenderer)();
  var styleEvent = (0, _react.useMemo)(function () {
    return (0, _resize.fromResize)(renderer.view).pipe((0, _operators.debounceTime)(100)).pipe((0, _operators.map)(function (_) {
      return styleOf(renderer, scaleMode);
    }));
  }, []);
  var builtinStyle = (0, _Ticker.useSubscribe)(styleEvent, (0, _react.useMemo)(function () {
    return styleOf(renderer, scaleMode);
  }, []));
  var style = (0, _react.useMemo)(function () {
    return _objectSpread({}, outerStyle, {}, builtinStyle);
  }, [outerStyle, builtinStyle]);
  return _react.default.createElement("div", {
    id: id,
    className: "".concat(className && "".concat(className, " "), "UI"),
    style: style
  }, children);
};

exports.UI = UI;